import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeviceState {
  loading: boolean;
  devices: any[];
  count: number;
  saveLoading: boolean;
  saveMessage: string;
  deleteLoading: boolean;
  deleteMessage: string;
  error: string;
}

const initialState: DeviceState = {
  loading: false,
  devices: [],
  count: 0,
  saveLoading: false,
  saveMessage: "",
  deleteLoading: false,
  deleteMessage: "",
  error: "",
};

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    // Fetch list
    getDevices: (state, _action: PayloadAction<any>) => {
      state.loading = true;
      state.error = "";
    },
    getDevicesSuccess: (state, action: PayloadAction<any>) => {
      state.loading = false;
      state.devices = action.payload?.data || action.payload?.devices || [];
      state.count = action.payload?.count || 0;
    },
    getDevicesFail: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add device
    addDevice: (state, _action: PayloadAction<any>) => {
      state.saveLoading = true;
      state.saveMessage = "";
    },
    addDeviceSuccess: (state, action: PayloadAction<string>) => {
      state.saveLoading = false;
      state.saveMessage = action.payload;
    },
    addDeviceFail: (state, action: PayloadAction<string>) => {
      state.saveLoading = false;
      state.error = action.payload;
    },

    // Update device
    updateDevice: (state, _action: PayloadAction<any>) => {
      state.saveLoading = true;
      state.saveMessage = "";
    },
    updateDeviceSuccess: (state, action: PayloadAction<string>) => {
      state.saveLoading = false;
      state.saveMessage = action.payload;
    },
    updateDeviceFail: (state, action: PayloadAction<string>) => {
      state.saveLoading = false;
      state.error = action.payload;
    },

    // Delete device
    deleteDevice: (state, _action: PayloadAction<string>) => {
      state.deleteLoading = true;
      state.deleteMessage = "";
    },
    deleteDeviceSuccess: (state, action: PayloadAction<string>) => {
      state.deleteLoading = false;
      state.deleteMessage = action.payload;
    },
    deleteDeviceFail: (state, action: PayloadAction<string>) => {
      state.deleteLoading = false;
      state.error = action.payload;
    },

    clearDeviceData: (state) => {
      state.saveMessage = "";
      state.deleteMessage = "";
      state.error = "";
    },
  },
});

export const deviceActions = deviceSlice.actions;

// Selectors
export const selectDeviceLoading       = (state: any) => state.device?.loading;
export const selectDevices             = (state: any) => state.device?.devices || [];
export const selectDeviceCount         = (state: any) => state.device?.count || 0;
export const selectDeviceSaveLoading   = (state: any) => state.device?.saveLoading;
export const selectDeviceSaveMessage   = (state: any) => state.device?.saveMessage;
export const selectDeviceDeleteLoading = (state: any) => state.device?.deleteLoading;
export const selectDeviceDeleteMessage = (state: any) => state.device?.deleteMessage;

export default deviceSlice.reducer;
